import flattenMessages from '../flattenMessages';
import en from './en.json';
import es from './es.json';
import ru from './ru.json';
import zh from './zh.json';

export default {
  en: flattenMessages(en, 'yearn-finance'),
  es: flattenMessages(es, 'yearn-finance'),
  ru: flattenMessages(ru, 'yearn-finance'),
  zh: flattenMessages(zh, 'yearn-finance'),
};
